import { useState } from 'react';
import { apiClient } from '../utils/apiErrorHandling';
import { createCrawlRequest } from '../types/product';

const useRecrawl = () => {
  const [recrawling, setRecrawling] = useState(false);

  const recrawlProduct = async (product) => {
    if (!product) return;
    
    setRecrawling(true);
    try {
      // URL 구성: 기본 URL + product_id
      const url = `https://www.oliveyoung.co.kr/store/goods/getGoodsDetail.do?goodsNo=${product.product_id}`;
      
      const crawlRequest = createCrawlRequest(product.source_site);
      crawlRequest.url = url;
      
      // 위버스 사이트인 경우 아티스트 정보 포함 (크롤링 시에는 딕셔너리 형태)
      if (product.source_site === 'weverse' && product.artist) {
        // artist가 문자열인 경우 딕셔너리로 변환
        if (typeof product.artist === 'string') {
          crawlRequest.artist = {
            name: product.artist,
            id: null
          };
        } else if (typeof product.artist === 'object' && product.artist.name) {
          // 이미 딕셔너리인 경우 그대로 사용
          crawlRequest.artist = product.artist;
        }
      }
      
      await apiClient.post('/crawler/crawl', crawlRequest, { timeout: 300000 }); // 5분 타임아웃
      
      return { success: true };
    } catch (error) {
      console.error('재크롤링 중 오류 발생:', error);
      throw error;
    } finally {
      setRecrawling(false);
    }
  };

  return {
    recrawling,
    recrawlProduct
  };
};

export default useRecrawl;
